import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import Router from 'util/Router';
import 'index.css';

ReactDOM.render(<Router />, document.getElementById('root'));
